// extracted by mini-css-extract-plugin
export default {"card":"chooseRestaurants_card__4UJgY","closeBtn":"chooseRestaurants_closeBtn__hGDfa","image":"chooseRestaurants_image__XyT9E"};